import { render } from "./BrandLayout.vue?vue&type=template&id=c75cf8e8"
import script from "./BrandLayout.vue?vue&type=script&lang=js"
export * from "./BrandLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__